import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { message } from 'antd';
import 'antd/dist/antd.min.css';
import App from 'app/App';
import store from 'app/store';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
      onError: (error: any) => {
        message.error(
          error.message || `Api call failed. Please contact Focus 360 with the current URL.`,
          5
        );
      },
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      {/* makes the Redux store available to rest of the App */}
      <Provider store={store}>
        <App />
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
